import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-section.service";

export const useAdminAssessmentSection = createUseData(
    service.getSection,
)